import { Component, Input, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

export interface RadioOption {
  id: string | number;
  text: string;
  description?: string;
  disabled?: boolean;
}

@Component({
  selector: 'app-radio-button',
  templateUrl: './radio-button.component.html',
  styleUrls: ['./radio-button.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => RadioButtonComponent),
      multi: true,
    },
  ],
})
export class RadioButtonComponent implements ControlValueAccessor {
  @Input() options: RadioOption[] = [];
  @Input() label: string = '';
  @Input() name: string = '';
  @Input() required: boolean = false;
  @Input() disabled: boolean = false;
  @Input() class: string = '';
  @Input() id: string = '';
  @Input() layout: 'vertical' | 'horizontal' = 'vertical';
  @Input() showDescriptions: boolean = true;

  value: string | number | null = null;
  touched: boolean = false;

  // ControlValueAccessor implementation
  onChange = (value: string | number | null) => {};
  onTouched = () => {};

  writeValue(value: string | number | null): void {
    this.value = value;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  onRadioChange(optionValue: string | number): void {
    if (!this.disabled) {
      this.value = optionValue;
      this.onChange(optionValue);
      this.onTouched();
    }
  }

  onBlur(): void {
    this.touched = true;
    this.onTouched();
  }

  isOptionDisabled(option: RadioOption): boolean {
    return this.disabled || option.disabled || false;
  }

  isOptionSelected(option: RadioOption): boolean {
    return this.value === option.id;
  }
}
